<div class="viewerAudioWrapper">
  @if (playerTitle) {
    <div class="playerTitle">
      {{ playerTitle }}
    </div>
  }
  @if (assetName) {
    <div class="assetNameWrapper">
      <div [id]="'assetName' + assetName" class="asset-name" [innerHTML]="assetName"></div>
      <div>{{ time }} / {{ duration }}</div>
    </div>
  }
  @let _audioFile = _audioFile$ | async;
  @if (_audioFile) {
    <audio
      #audio
      id="{{ assetName }}"
      class="w-100"
      src="{{ _audioFile }}"
      controls
      crossorigin="anonymous"
      preload="auto"
      (timeupdate)="setTime($event)"
      (durationchange)="setDuration($event)"
      (play)="playStarted()"
      (pause)="pauseStarted()"
      (error)="onAudioError($event)"
      [attr.aria-describedby]="'assetName' + assetName"
      [autoplay]="autoplay">
      Your browser does not support the <code>audio</code> element.
    </audio>
  } @else {
    <zbp-preloader spinnerHeight="54px"/>
  }
  @if (errorMessage) {
    <div class="errorMessage">
      {{ errorMessage }}
    </div>
  } @else {
    <div class="audioControls">
      <zbp-button-component
        id="rewindButton"
        type="button"
        [ariaLabel]="'Rewind'"
        (clickHandler)="skipBackwards(10)"
        [attr.aria-label]="'Rewind'"
        [theme]="'blackText'"
        [iconSize]="'font-size'"
        [iconPosition]="'right'"
        [tooltip]="'Rewind'"
        [iconName]="zbpIconNames.audioRewindIcon"
      />
      <zbp-button-component
        id="playButton"
        type="button"
        [ariaLabel]="playButtonText"
        (clickHandler)="playOrPause()"
        [attr.aria-label]="playButtonText"
        [theme]="'blackText'"
        [iconSize]="'font-size'"
        [iconPosition]="'right'"
        [tooltip]="playButtonText"
        [tooltipTriggers]="'hover focus'"
        [iconName]="icon"
      />
      <zbp-button-component
        id="fastForwardButton"
        type="button"
        [ariaLabel]="'Fast Forward'"
        (clickHandler)="skipForward(10)"
        [attr.aria-label]="'Fast Forward'"
        [theme]="'blackText'"
        [iconSize]="'font-size'"
        [iconPosition]="'right'"
        [tooltip]="'Fast Forward'"
        [iconName]="zbpIconNames.audioFastForwardIcon"
      />
    </div>
  }
  <div class="sr-only" aria-live="polite" aria-atomic="true">{{ announcement }}</div>
</div>
